import React from "react"
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import classes from "./Settings.module.css"


function Permissions({ permissions, handleCheckUpdate, shared }) {

    // changes name from assessment to metric
    const displayName = (name) => {
        if (name === "assessmentList") {
            return "metric list"
        } else if (name === "assessment") {
            return "metric progress"
        } else if (name==="diet") {
            return "nutrition"
        } else {
            return `${name}`
        }
    }


    let sortedClientPermissions = Array(7);
    permissions && Object.entries(permissions).map(([name, value]) => {
        switch (name) {
            case ("workout"):
                return sortedClientPermissions[0] = { name, value }
            case ("exercise"):
                return sortedClientPermissions[1] = { name, value }
            case ("diet"):
                return sortedClientPermissions[2] = { name, value }
            case ("food"):
                return sortedClientPermissions[3] = { name, value }
            case ("task"):
                return sortedClientPermissions[4] = { name, value }
            case ("assessment"):
                return sortedClientPermissions[5] = { name, value }
            case ("assessmentList"):
                return sortedClientPermissions[6] = { name, value }

        }
    })

    return (
        <Card className={`${classes.cardWidth} mb-5 shadow px-5`}>
            <Card.Body>
                <h4>{shared&&'Shared '}Client Permissions</h4>
                <hr class="mt-1 mb-4" />
        
                {permissions && sortedClientPermissions.map(({ name, value }) => {
                    if (name==="nutrition") {
                        return
                    }

                    let checked;
                    let dbField = name + "_edit"
                    let message;

                    if (value == "1" || value === true) {
                        checked = true
                    } else {
                        checked = false;
                    }

                    let addEdit = ["workout", "assessment", "diet", "task"]
                    if (addEdit.includes(name)) {
                        message = "Client can edit / add"
                    } else {
                        message = "Client can create their own list"
                    }

                    return (
                        <Row key={name} className="d-flex align-items-center justify-content-center mb-3">
                            <Col >
                                <div className="d-flex align-items-center" style={{ textTransform: "capitalize" }}>
                                    {displayName(name)}
                                </div>
                            </Col>
                            <Col >
                                <div className="">
                                    <Form.Group className="mb-0" controlId={name}>
                                        <Form.Check className="" name={name} label={message} onChange={(e) => {
                                            let name = e.target.name
                                            let currCheck = e.target.checked
                                            handleCheckUpdate(name, currCheck, "edit_permissions", dbField)
                                        }}

                                            checked={checked} type="checkbox" className="custom-control custom-checkbox" >
                                        </Form.Check >
                                    </Form.Group>
                                </div>
                            </Col>
                        </Row>
                    )
                }
                )}

            </Card.Body>

        </Card>
    )

}
export default Permissions